import { render, staticRenderFns } from "./NRadio.vue?vue&type=template&id=56edff8a"
import script from "./NRadio.vue?vue&type=script&lang=js"
export * from "./NRadio.vue?vue&type=script&lang=js"
import style0 from "./NRadio.vue?vue&type=style&index=0&id=56edff8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports